<div class="sh-content-context-layout">
    <div class="sh-content-context-layout__content">
        <div [class]="className">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
        <ng-content></ng-content>
    </div>
    <div *ngIf="context" class="sh-content-context-layout__context">
        <ng-container *ngTemplateOutlet="context"></ng-container>
    </div>
</div>
